// extracted by mini-css-extract-plugin
export var bankProvider = "PreviewCustomTable-module--bankProvider--eebbc";
export var icon = "PreviewCustomTable-module--icon--523ab";
export var lgBreak = "1200";
export var mdBreak = "992";
export var previewCustomTable = "PreviewCustomTable-module--previewCustomTable--44d83";
export var previewCustomTableContainer = "PreviewCustomTable-module--previewCustomTableContainer--a8f3e";
export var smBreak = "768";
export var starling = "PreviewCustomTable-module--starling--bcfd2";
export var sticky = "PreviewCustomTable-module--sticky--ee7e5";
export var xsBreak = "480";